"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN = void 0;
exports.MIN = {
    alias: 'MINIMO',
    description: 'Retorna o menor número dado uma lista de valores',
    arg_names: ['número...'],
    args_description: [
        'Qualquer número, ou referência a uma célula contendo um número, que você deseja encontrar o menor valor. Qualquer campo que não seja número ou vazio será ignorado',
    ],
};
